/**
 * Tiny wrapper around the Vibration API. No-ops where unsupported (iOS Safari
 * doesn't fire navigator.vibrate but does respect Apple-style haptic via tap
 * highlights). Calling this never throws.
 */
type Pattern = "tap" | "success" | "open";

const PATTERNS: Record<Pattern, number | number[]> = {
  tap: 18,
  open: 30,
  success: [40, 60, 40],
};

export function buzz(kind: Pattern = "tap"): void {
  try {
    if (typeof navigator === "undefined") return;
    const pattern = PATTERNS[kind];
    navigator.vibrate?.(pattern);
  } catch {
    /* ignore */
  }
}
